const Contact = () => import('./Contact')
const SubscribeForm = () => import('./SubscribeForm')

export default function install(Vue) {
  Vue.component('contact-form', Contact)
  Vue.component('subscribe-form', SubscribeForm)
}
